import { CalendarDays, MapPin } from "lucide-react";
import { useFetch } from "@/hooks/useFetch";
import { Seo } from "@/components/site/Seo";
import { PageHero } from "@/components/site/PublicLayout";
import { fmtDate, todayTR } from "@/lib/helpers";

function EventCard({ e, past }) {
  return (
    <article className={`rounded-3xl overflow-hidden border border-bej bg-white flex flex-col sm:flex-row ${past ? "opacity-70" : ""}`} data-testid={`event-card-${e.id}`}>
      {e.image_url && <img src={e.image_url} alt={e.title} className="sm:w-64 aspect-[16/10] sm:aspect-auto object-cover" loading="lazy" />}
      <div className="p-6 flex flex-col gap-2">
        <p className="flex items-center gap-2 text-sm font-bold text-navy/70"><CalendarDays className="w-4 h-4" />{fmtDate(e.date)} {e.time}</p>
        <h2 className="font-heading text-xl font-extrabold text-navy">{e.title}</h2>
        {e.location && <p className="flex items-center gap-2 text-sm text-slate-600"><MapPin className="w-4 h-4" />{e.location}</p>}
        <p className="text-sm text-slate-600 leading-relaxed whitespace-pre-line">{e.description}</p>
      </div>
    </article>
  );
}

export default function Events() {
  const { data } = useFetch("/events");
  const today = todayTR();
  const upcoming = (data || []).filter((e) => e.date >= today);
  const past = (data || []).filter((e) => e.date < today).reverse();
  return (
    <>
      <Seo title="Etkinlikler ve Konserler" description="Masal Sanat Akademi öğrenci dinletileri, konserler ve etkinlik takvimi." />
      <PageHero eyebrow="Etkinlikler" title="Konserler ve dinletiler" />
      <section className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8 py-14 space-y-12">
        <div className="space-y-5" data-testid="events-upcoming">
          <h2 className="font-heading text-2xl font-black text-navy">Yaklaşan</h2>
          {!data ? <p className="text-slate-400">Yükleniyor…</p> : upcoming.length ? upcoming.map((e) => <EventCard key={e.id} e={e} />) : <p className="text-slate-600">Şu an planlanmış bir etkinlik yok.</p>}
        </div>
        {past.length > 0 && (
          <div className="space-y-5" data-testid="events-past">
            <h2 className="font-heading text-2xl font-black text-navy">Geçmiş etkinlikler</h2>
            {past.map((e) => <EventCard key={e.id} e={e} past />)}
          </div>
        )}
      </section>
    </>
  );
}
